import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import qs from 'qs';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';
import {
  DISPENSARIZATION_STATISTICS_KEYS_NAMES,
  DispensarizationStatisticsParameters,
} from '../../hooks/components/useDispensarizationStatistics/constants';

export interface DispensarizationStatisticsState {
  results: Record<DISPENSARIZATION_STATISTICS_KEYS_NAMES, number>;
  status: Status;
}

export interface DispensarizationStatisticsStage {
  count: number;
  stage: string;
}

export interface DispensarizationStatisticsRequest {
  From: string;
  To: string;
  ClinicIds: string[];
  BatchIds: string[];
}

const initialState: DispensarizationStatisticsState = {
  results: {} as Record<DISPENSARIZATION_STATISTICS_KEYS_NAMES, number>,
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getDispensarizationStatistics = createAsyncThunk(
  'DispensarizationStatistics/getDispensarizationStatistics',
  async (request: DispensarizationStatisticsRequest, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.get<
        Record<DISPENSARIZATION_STATISTICS_KEYS_NAMES, number>
      >('task/dispensarization/statistic', {
        params: {
          [DispensarizationStatisticsParameters.From]: request.From,
          [DispensarizationStatisticsParameters.To]: request.To,
          [DispensarizationStatisticsParameters.ClinicIds]: request.ClinicIds,
          [DispensarizationStatisticsParameters.BatchIds]: request.BatchIds,
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить статистику!');
    }
  },
);

export const dispensarizationStatisticsSlice = createSlice({
  name: 'dispensarizationStatistics',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getDispensarizationStatistics.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getDispensarizationStatistics.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.results = action.payload;
        return state;
      })
      .addCase(getDispensarizationStatistics.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось загрузить статистику';
        return state;
      });
  },
});

export default dispensarizationStatisticsSlice.reducer;

export const results = (state: RootState) =>
  state.dispensarizationStatistics.results;

export const dispensarizationStatisticsStatus = (state: RootState) =>
  state.dispensarizationStatistics.status;
